module.exports = __webpack_public_path__ + "static/media/close-blue.08af4aff.svg";